import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { smsConsentActions } from 'actions';
import { DEFAULT_VERSION, SMS, OPT_IN, OPT_OUT, APP_FLOW } from 'shared/constants/sms-consent';
import useIdentity from './useIdentity';

const FIGURE = 'FIGURE';

const useSmsConsent = (version = DEFAULT_VERSION, load = true) => {
  const org = FIGURE; // update if we ever offer this elsewhere
  const source = APP_FLOW; // expand this if needed in the future
  const dispatch = useDispatch();
  const state = useSelector(state => state.smsConsentReducer);
  const { smsUuid } = state;
  const { jwt } = useIdentity();

  const getSmsInfo = useCallback(
    async version => dispatch(jwt ? smsConsentActions.getSMSInfo(version) : smsConsentActions.getSMSInfoExternal(version)),
    [dispatch, jwt]
  );
  const getUserSmsState = useCallback(
    async ({ email, phone }) =>
      dispatch(
        smsConsentActions.getUserSmsState({
          consent_type: SMS,
          org,
          email,
          phone,
        })
      ),
    [dispatch, org]
  );
  const saveSmsOptInOut = useCallback(
    async ({ optIn = false, phone, email }) => {
      try {
        smsUuid &&
          phone &&
          email &&
          (await dispatch(
            smsConsentActions.saveSMSOptInOut({
              source,
              org,
              phone,
              email,
              consents: [
                {
                  consent_prompt_uuid: smsUuid,
                  opt_in_out: optIn ? OPT_IN : OPT_OUT,
                },
              ],
              product_type: 'PL',
            })
          ));
      } catch (e) {
        /* noop */
      }
    },
    [dispatch, org, smsUuid, source]
  );

  useEffect(() => {
    (async () => {
      try {
        load && (await getSmsInfo(version !== DEFAULT_VERSION && version));
      } catch (e) {
        /* noop */
      }
    })();
  }, [version, dispatch, getSmsInfo, load]);

  return {
    ...state,
    getSmsInfo,
    getUserSmsState,
    saveSmsOptInOut,
  };
};

export default useSmsConsent;
